import { render } from "./projectRecentChats.vue?vue&type=template&id=36f50065&ts=true"
import script from "./projectRecentChats.vue?vue&type=script&lang=ts"
export * from "./projectRecentChats.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__